import { Inject, Injectable } from '@angular/core';
import { AppService } from '../../app.service';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CampaignTrackersService {
 private _etlApiBaseUrl: string = '';
  
  public constructor(private appService: AppService, public http: HttpClient, @Inject('ETL_API_BASE_URL') baseurl: string) {
    this._etlApiBaseUrl = baseurl;
  }

  public get = (page: number = 1, pageSize: number = 10, sortBy: string = 'CampaignTrackerId', sortOrder:string = 'DESC'): Observable<any> => {
    let result: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    const apipath: string = 'campaign-tracker/global-list?page='+page+'&pageSize='+pageSize+'&sortBy='+sortBy+'&sortOrder='+sortOrder;
    const fullPath: string = this._etlApiBaseUrl + apipath;
    const options = this.appService.getHttpHeaderOptions();

    return this.http.get<any>(fullPath, options);
  }
}

